/** @file Layout primitives: gutters, content widths, touch targets, app rails. */

export const layout = {
  // WCAG 2.5.8 / Apple HIG minimum tap target on touch devices.
  touchTarget: '44px',
  // Fluid page gutter: 16px on phones, 32px on wide screens, no media query.
  gutter: 'clamp(16px, 4vw, 32px)',
  // Content max-widths consumed by PageContainer (narrow = forms/prose,
  // default = standard pages, wide = dashboards/tables).
  contentMaxNarrow: '720px',
  contentMax: '1280px',
  contentMaxWide: '1536px',
  // Trip-guide editor/public sidebar: 600px on large desktop (>=1429px),
  // proportional below so tablets keep usable content width.
  sidebarLg: 'min(600px, 42vw)',
  // Trip-guide reader (blog article) panel: 720px prose + gutters. The map
  // maximize toggle swaps the panel back to sidebarLg.
  readerLg: 'min(800px, 56vw)',
  // TGEditorSideBar icon rail width.
  railW: '80px',
  // Space reserved above StickyMobileCTA so content is never hidden behind it.
  stickyCtaH: '72px',
  // The host service editor dialog. Wide enough for the 12rem step rail to sit
  // beside the form from md up; Mantine clamps it to the viewport below that,
  // and ResponsiveModal goes fullscreen on phones regardless.
  editorDialogW: '960px'
};
